import React from 'react'
import clsx from 'clsx'

import { Input, Select, FormControl, FormHelperText, makeStyles } from '@material-ui/core'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
}

const useStyles = makeStyles(() => ({
  formControl: {
    width: '100%'
  }
}))

/**
 * @param {{
 *    id: string
 *    name: string
 *    iTouched?: any
 *    iError?: any
 * }} props
 * @returns {React.Component}
 */
const MultipleSelectFormGroup = ({ id, name, iTouched, iError, ...props }) => {
  const classes = useStyles()

  return (
    <FormControl className={clsx(classes.formControl)} error={iTouched && iError ? true : false}>
      <Select
        {...props}
        multiple
        displayEmpty
        input={<Input id={id} name={name} />}
        renderValue={selected => {
          if (selected.length === 0) {
            return <em>Seleccionar</em>
          }

          return `${selected.length} seleccionado(s)`
        }}
        MenuProps={MenuProps}
      />
      {iTouched && iError ? <FormHelperText>{iError}</FormHelperText> : null}
    </FormControl>
  )
}

export default React.memo(MultipleSelectFormGroup)
